export default function routes(router) {
	function redirectCore(path, localStorageKey, fallbackPath) {
		let link = router.resolve(path);
		if (!link) {
			localStorage.removeItem(localStorageKey);
			return { path: fallbackPath };
		}
		return { path };
	}

	function parentRedirect(parentName, defaultRoutePath) {
		let lastRoutePath = localStorage.getItem(`${parentName}-lastRoute`) || defaultRoutePath;
		if (!lastRoutePath) throw new Error('Last route path not found. Make sure a default route path is set.');
		return redirectCore(lastRoutePath, `${parentName}-lastRoute`, defaultRoutePath);
	}

	function beforeEnterChildRoute(to, from, next) {
		let [ , parentName ] = to.fullPath.split('/');
		localStorage.setItem(`${parentName}-lastRoute`, to.path);
		localStorage.setItem('root-lastRoute', to.path);
		next();
	}

	return [
		{
			path: '/',
			redirect: () => {
				let lastRoutePath = localStorage.getItem('root-lastRoute') || '/operational';
				return redirectCore(lastRoutePath, 'root-lastRoute', '/operational');
			},
		},
		{
			path: '/operational',
			name: 'operational',
			component: () => import(/* webpackChunkName: "operational" */ './operational/Operational.vue'),
			redirect: () => parentRedirect('operational', '/operational/tripSearch'),
			children: [
				{
					path: 'loadPlanning/list',
					name: 'loadPlanningList',
					component: () => import(/* webpackChunkName: "loadPlanningList" */ './loadPlanningList/loadPlanningList.vue'),
					props: true,
					beforeEnter: beforeEnterChildRoute,
				},
				{
					path: 'loadPlanning/list/:searchId',
					name: 'savedLoadPlanningList',
					component: () => import(/* webpackChunkName: "loadPlanningList" */ './loadPlanningList/loadPlanningList.vue'),
					beforeEnter: beforeEnterChildRoute,
				},
				{
					path: 'loadPlanning/map',
					name: 'loadPlanningMap',
					component: () => import(/* webpackChunkName: "loadPlanning" */ './loadPlanningList/loadPlanningMap.vue'),
					beforeEnter: beforeEnterChildRoute
				},
				{
					path: 'loadPlanning/map/:searchId',
					name: 'savedLoadPlanningMap',
					component: () => import(/* webpackChunkName: "loadPlanning" */ './loadPlanningList/loadPlanningMap.vue'),
					beforeEnter: beforeEnterChildRoute
				},
				{
					path: 'loadPlanning/map/trip/:tripId',
					name: 'savedLoadPlanningMapTrip',
					component: () => import(/* webpackChunkName: "loadPlanning" */ './loadPlanningList/loadPlanningMap.vue'),
					beforeEnter: beforeEnterChildRoute
				},
				{
					path: 'orderSearch',
					name: 'orderSearch',
					component: () => import(/* webpackChunkName: "orderSearch" */ './orderSearch/OrderSearch.vue'),
					beforeEnter: beforeEnterChildRoute,
				},
				{
					path: 'orderSearch/:searchId',
					name: 'savedOrderSearch',
					component: () => import(/* webpackChunkName: "orderSearch" */ './orderSearch/OrderSearch.vue'),
					beforeEnter: beforeEnterChildRoute,
				},
				{
					path: 'tripSearch',
					name: 'tripSearch',
					component: () => import(/* webpackChunkName: "tripSearch" */ './tripSearch/TripSearch.vue'),
					beforeEnter: beforeEnterChildRoute,
				},
				{
					path: 'tripSearch/:searchId',
					name: 'savedTripSearch',
					component: () => import(/* webpackChunkName: "orderSearch" */ './tripSearch/TripSearch.vue'),
					beforeEnter: beforeEnterChildRoute,
				},
				{
					path: 'locationsMap',
					name: 'locationsMap',
					component: () => import(/* webpackChunkName: "locationsMap" */ './locations/LocationsMap.vue'),
					beforeEnter: beforeEnterChildRoute
				},
				{
					path: 'locationsMap/:areaId',
					name: 'savedLocationsMap',
					component: () => import(/* webpackChunkName: "locationsMap" */ './locations/LocationsMap.vue'),
					beforeEnter: beforeEnterChildRoute
				},
				{
					path: 'unknownSearch',
					name: 'unknownSearch',
					component: () => import(/* webpackChunkName: "unknownSearch" */ './unknownItems/UnknownSearch.vue'),
					bedforeEnter: beforeEnterChildRoute
				},
				{
					path: 'edi',
					name: 'edi',
					component: () => import(/* webpackChunkName: "admin" */ './edi/Edi.vue'),
					beforeEnter: beforeEnterChildRoute,
				},
				{
					path: 'deviationSearch',
					name: 'deviationSearch',
					component: () => import(/* webpackChunkName: "deviationSearch" */ './deviationSearch/DeviationSearch.vue'),
					beforeEnter: beforeEnterChildRoute
				},
			]
		},
		{
			path: '/maintenance',
			name: 'maintenance',
			component: () => import(/* webpackChunkName: "maintenance" */ './maintenance/Maintenance.vue'),
			redirect: () => parentRedirect('maintenance', '/maintenance/tripAddresses'),
			children: [
				{
					path: 'edipartMaintenance',
					name: 'edipartMaintenance',
					component: () => import(/* webpackChunkName: "admin" */ './edi/EdipartsMaintenance.vue'),
					beforeEnter: beforeEnterChildRoute,
				},
				{
					path: 'cargoCarriers',
					name: 'cargoCarriers',
					component: () => import(/* webpackChunkName: "cargoCarriers" */ './cargoCarriers/CargoCarriers.vue'),
					beforeEnter: beforeEnterChildRoute,
				},
				{
					path: 'cargoCarrierTypes',
					name: 'cargoCarrierTypes',
					component: () => import(/* webpackChunkName: "cargoCarrierTypes" */ './cargoCarrierTypes/CargoCarrierTypes.vue'),
					beforeEnter: beforeEnterChildRoute,
				},
				{
					path: 'goodsTypes',
					name: 'goodsTypes',
					component: () => import(/* webpackChunkName: "goodsTypes" */ './goodsTypes/GoodsTypes.vue'),
					beforeEnter: beforeEnterChildRoute,
				},
				{
					path: 'tripTemplates',
					name: 'tripTemplates',
					component: () => import(/*webpackChunkName: "tripTemplates" */ './tripTemplates/TripTemplates.vue'),
					beforeEnter: beforeEnterChildRoute,
				},
				{
					path: 'orderTemplates',
					name: 'orderTemplates',
					component: () => import(/*webpackChunkName: "orderTemplates" */ './orderTemplates/OrderTemplates.vue'),
					beforeEnter: beforeEnterChildRoute,
				},
				{
					path: 'users',
					name: 'userList',
					component: () => import(/* webpackChunkName: "userList" */ './users/UserList.vue'),
					beforeEnter: beforeEnterChildRoute,
				},
				{
					path: 'deviations',
					name: 'deviations',
					component: () => import(/* webpackChunkName: "deviations" */ './deviations/Deviations.vue'),
					beforeEnter: beforeEnterChildRoute,
				},
				{
					path: 'incoterms',
					name: 'incoterms',
					component: () => import(/* webpackChunkName: "incoterms" */ './incoterms/Incoterms.vue'),
					beforeEnter: beforeEnterChildRoute,
				},
				{
					path: 'packageTypes',
					name: 'packageTypes',
					component: () => import(/* webpackChunkName: "packageTypes" */ './packageTypes/PackageTypes.vue'),
					beforeEnter: beforeEnterChildRoute,
				},
				{
					path: 'terminals',
					name: 'terminals',
					redirect: { name: 'tripAddresses' },
				},
				{
					path: 'addresses',
					name: 'addresses',
					component: () => import(/* webpackChunkName: "addresses" */ './globalAddresses/GlobalAddressRegistry.vue'),
					beforeEnter: beforeEnterChildRoute,
				},
				{
					path: 'tripAddresses',
					name: 'tripAddresses',
					component: () => import(/* webpackChunkName: "tripAddresses" */ './tripAddresses/TripAddresses.vue'),
					beforeEnter: beforeEnterChildRoute,
				},
				{
					path: 'references',
					name: 'references',
					component: () => import(/* webpackChunkName: "references" */ './references/References.vue'),
					beforeEnter: beforeEnterChildRoute,
				},
				{
					path: 'drivers',
					name: 'drivers',
					component: () => import(/* webpackChunkName: "references" */ './drivers/Drivers.vue'),
					beforeEnter: beforeEnterChildRoute,
				},
				{
					path: 'preferredVendors',
					name: 'preferredVendors',
					component: () => import(/* webpackChunkName: "references" */ './preferredVendors/PreferredVendors.vue'),
					beforeEnter: beforeEnterChildRoute,
				},
				{
					path: 'vendors',
					name: 'vendors',
					component: () => import(/* webpackChunkName: "references" */ './vendors/Vendors.vue'),
					beforeEnter: beforeEnterChildRoute,
				},
			]
		},
	];
}
